import $ from "jquery";
import {
  bindSearchDropdowns,
} from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  dropdowns: $(`.search-box-field`),
};
const selectAllButton = $(`.select-all-products`);
const unselectAllButton = $(`.unselect-all-products`);
const warehouseProductsCheckboxes = $(`.trading-partner-option-for-warehouse-product`);

export default class WarehouseWarehouseProductsService {
  constructor() {
    this.selectAllButton = selectAllButton;
    this.unselectAllButton = unselectAllButton;
    this.warehouseProductsCheckboxes = warehouseProductsCheckboxes;
    this.searchFormElements = searchFormElements;

    this.bindCheckBoxes();
    this.bindElements();
  }

  static init() {
    if ($(`.warehouse-warehouse-products-form`).length === 0) {
      return undefined;
    }

    return new WarehouseWarehouseProductsService();
  }

  bindCheckBoxes() {
    this.selectAllButton.click(() => {
      this.warehouseProductsCheckboxes.prop(`checked`, true);
    });
    this.unselectAllButton.click(() => {
      this.warehouseProductsCheckboxes.prop(`checked`, false);
    });
  }

  bindElements() {
    bindSearchDropdowns(this.searchFormElements);
  }
}
